import { render, staticRenderFns } from "./wy.vue?vue&type=template&id=62508bbf&scoped=true"
import script from "./wy.vue?vue&type=script&lang=js"
export * from "./wy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62508bbf",
  null
  
)

export default component.exports